import React, { memo } from "react";
import { Stack } from "investira.react.components";
import { validators } from "investira.sdk";

const ConcentracaoGraph = memo((props) => {
  const { range, alvo, minimo, observado, targetColor } = props;

  const xEnquadramentoRange = range;
  const xAlvo = alvo;
  const xObservado = observado;
  const hasAlvo = !validators.isNull(alvo.alvo);

  return (
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        height: "26px",
        minWidth: "100px",
        borderRadius: 1,
        overflow: "hidden",
        position: "relative",
      }}
    >
      <Stack
        id="bg-bar"
        sx={{
          backgroundColor: "background.main",
          borderWidth: 1,
          borderColor: "secondary.main",
          borderStyle: "solid",
          borderRadius: 1,
          position: "relative",
          height: "26px",
          minWidth: "100%",
        }}
      />
      <Stack
        id="bg-bar-enquadramento"
        sx={{
          //backgroundColor: "primary.main",
          opacity: 0.72,
          backgroundColor: "text.secondary",
          borderRadius: 1,
          position: "absolute",
          top: 1,
          bottom: 0,
          left: `${minimo}%`,
          //right: 50,
          height: "24px",
          minWidth: `${xEnquadramentoRange}%`,
        }}
      />
      {hasAlvo && (
        <Stack
          id="bg-bar-alvo"
          sx={{
            //backgroundColor: "primary.main",
            backgroundColor: "info.main",
            borderRadius: 1,
            position: "absolute",
            top: 1,
            bottom: 0,
            left: `${xAlvo.alvoLimites.minimo}%`,
            //right: 50,
            height: "24px",
            minWidth: xAlvo > 0 ? "2px" : 0,
            width: `${xAlvo.alvoWidth}%`,
          }}
        />
      )}
      <Stack
        id="bg-bar-observado"
        sx={{
          backgroundColor: targetColor,
          borderRadius: 1,
          position: "absolute",
          top: 1,
          bottom: 0,
          left: xObservado,
          //right: 50,
          height: "24px",
          minWidth: "2px",
          width: "1%",
        }}
      />
    </Stack>
  );
});

export default ConcentracaoGraph;
